var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiCharacterGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 94,
    viewBox: "0 0 98 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.07569e-06 50.8182C-1.16193e-06 72.7091 13.524 86 27.44 86C35.6449 86 41.9425 82.4818 49.96 82.4818C57.9775 82.4818 63.8043 86 70.56 86C77.616 86 98 83.0682 98 50.8182C98 18.5682 79.0125 7.21902e-07 67.032 1.76927e-06C56.9625 2.64957e-06 55.664 7.81819 49.98 7.81819C44.296 7.81819 43.512 3.82545e-06 33.124 4.7336e-06C16.072 6.22434e-06 -4.98946e-06 28.9273 -3.07569e-06 50.8182Z",
    fill: "url(#paint0_radial_657_2730)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4702 80.1997C27.7421 80.1997 22.141 84.7412 20.9388 90.7447C20.6753 92.0606 21.7881 93.1597 23.1302 93.1597H45.8102C47.1522 93.1597 48.2651 92.0606 48.0015 90.7447C46.7993 84.7412 41.1983 80.1997 34.4702 80.1997Z",
    fill: "url(#paint1_radial_657_2730)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0698 80.1997C58.3417 80.1997 52.7407 84.7412 51.5385 90.7447C51.2749 92.0606 52.3878 93.1597 53.7298 93.1597H76.4098C77.7519 93.1597 78.8647 92.0606 78.6012 90.7447C77.399 84.7412 71.7979 80.1997 65.0698 80.1997Z",
    fill: "url(#paint2_radial_657_2730)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 34.92H44.56L36.24 27",
    stroke: "#162430",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6816 34.92H55.1216L63.4416 27",
    stroke: "#162430",
    strokeWidth: 2.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_657_2730",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49 36.5) rotate(90) scale(52 59.2558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.600962,
    stopColor: "#BCF0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93DBC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_657_2730",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4702 84.2497) rotate(90) scale(10.35 21.9938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63DEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#57D1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DC7A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_657_2730",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.0698 84.2497) rotate(90) scale(10.35 21.9938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63DEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#57D1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DC7A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCharacterGood);
export default __webpack_public_path__ + "static/media/ai-character-good.c16be69fbdf5bfccb964d9e1e93f46f4.svg";
export { ForwardRef as ReactComponent };